/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfigurationDto } from '../models/ConfigurationDto';
import type { ConfigurationDto2 } from '../models/ConfigurationDto2';
import type { ConfigurationPrintOptionPersonalizationDto } from '../models/ConfigurationPrintOptionPersonalizationDto';
import type { ConfigurationPrintProofDto } from '../models/ConfigurationPrintProofDto';
import type { ConfiguratorLayout } from '../models/ConfiguratorLayout';
import type { PrintOptionPersonalizationDto } from '../models/PrintOptionPersonalizationDto';
import type { PrintProofReviewDto } from '../models/PrintProofReviewDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConfigurationService {

    /**
     * @returns string Successfully created new configuration
     * @throws ApiError
     */
    public static postSaveConfiguration({
        country,
        debtor,
        requestBody,
    }: {
        /**
         * Country code
         */
        country?: string,
        /**
         * Debtor code
         */
        debtor?: string,
        /**
         * Configuration
         */
        requestBody?: ConfigurationDto,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurations',
            query: {
                'country': country,
                'debtor': debtor,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `No product found for identifier "12345".`,
            },
        });
    }

    /**
     * @returns ConfigurationDto2 Requested configuration found.
     * @throws ApiError
     */
    public static getShowConfiguration({
        uuid,
        locale,
        country,
        debtor,
        vatRate,
        validateStock,
        layout,
    }: {
        /**
         * An existing configuration UUID.
         */
        uuid: string,
        /**
         * Locale
         */
        locale: string,
        /**
         * Country code
         */
        country?: string,
        /**
         * Debtor code
         */
        debtor?: string,
        /**
         * VAT rate
         */
        vatRate?: string,
        /**
         * Toggle to enable stock validation
         */
        validateStock?: 0 | 1,
        layout?: ConfiguratorLayout,
    }): CancelablePromise<ConfigurationDto2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurations/{uuid}',
            path: {
                'uuid': uuid,
            },
            query: {
                'locale': locale,
                'country': country,
                'debtor': debtor,
                'vatRate': vatRate,
                'validateStock': validateStock,
                'layout': layout,
            },
            errors: {
                404: `Requested configuration not found.`,
            },
        });
    }

    /**
     * @returns any Configuration is removed.
     * @throws ApiError
     */
    public static deleteDeleteConfiguration({
        uuid,
    }: {
        /**
         * An existing configuration UUID.
         */
        uuid: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/configurations/{uuid}',
            path: {
                'uuid': uuid,
            },
            errors: {
                404: `Requested configuration not found.`,
            },
        });
    }

    /**
     * @returns any Successfully saved new personalization
     * @throws ApiError
     */
    public static putSavePersonalization({
        configurationId,
        printOptionCode,
        locale,
        requestBody,
    }: {
        configurationId: string,
        printOptionCode: string,
        /**
         * Locale
         */
        locale?: string | null,
        /**
         * Personalization
         */
        requestBody?: PrintOptionPersonalizationDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurations/{configurationId}/print-options/{printOptionCode}/personalization',
            path: {
                'configurationId': configurationId,
                'printOptionCode': printOptionCode,
            },
            query: {
                'locale': locale,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Personalization is not valid.`,
                404: `Requested configuration not found.`,
            },
        });
    }

    /**
     * @returns any Successfully saved new print proof for configuration
     * @throws ApiError
     */
    public static postSavePrintProof({
        productionOrderNumber,
        requestBody,
    }: {
        /**
         * An existing production order number.
         */
        productionOrderNumber: string,
        /**
         * Print proof
         */
        requestBody?: ConfigurationPrintProofDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/configurations/{productionOrderNumber}/print-proofs',
            path: {
                'productionOrderNumber': productionOrderNumber,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Configuration has no order number defined.`,
                404: `Order item not found.`,
            },
        });
    }

    /**
     * @returns ConfigurationPrintOptionPersonalizationDto A collection of personalizations per print option for a given configuration.
     * @throws ApiError
     */
    public static getShowConfigurationPersonalizations({
        uuid,
    }: {
        /**
         * An existing configuration UUID.
         */
        uuid: string,
    }): CancelablePromise<Array<ConfigurationPrintOptionPersonalizationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/configurations/{uuid}/personalizations',
            path: {
                'uuid': uuid,
            },
            errors: {
                404: `Requested configuration not found.`,
            },
        });
    }

    /**
     * @returns any Successfully related the print proof review to the requested configuration.
     * @throws ApiError
     */
    public static putUpdatePrintProofReview({
        storeCode,
        uuid,
        requestBody,
    }: {
        /**
         * Store code for Commerce Engine
         */
        storeCode: string,
        /**
         * An existing configuration UUID.
         */
        uuid: string,
        /**
         * The print proof review.
         */
        requestBody?: PrintProofReviewDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/configurations/{uuid}/print-proof/review',
            path: {
                'uuid': uuid,
            },
            query: {
                'storeCode': storeCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid JSON document, or illegal update action.`,
                404: `Requested configuration not found.`,
            },
        });
    }

}
